import 'core-js';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import App from './app/App';
import CommunityApp from './app/CommunityApp';
import ScrollToTop from './app/ScrollToTop';
import { initializeGtm } from './components/TapPageVarSnippets';
import { IsCommunity } from './helpers/Helpers';
import store from './redux/store/index';

initializeGtm();

const container = document.getElementById('root');
const root = createRoot(container);
const isCommunity = IsCommunity();

root.render(
    <Provider store={store}>
        <BrowserRouter basename="/">
            <ScrollToTop>{isCommunity ? <CommunityApp /> : <App />}</ScrollToTop>
        </BrowserRouter>
    </Provider>
);
